import React, { useState } from 'react'
import { Send, Linkedin, Github, Twitter, Instagram, Mail, Phone } from 'lucide-react'
import { GradientContainer } from '../components'

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div className='text-white p-4 md:p-8 h-full w-full overflow-y-auto hide-scrollbar'>
      <div className='w-full h-full flex flex-col min-h-full'>
        {/* Header - Added top padding for mobile menu button */}
        <div className='mb-8 pt-safe-top md:pt-0'>
          <h1 className='text-3xl md:text-5xl font-stretchRegular mb-2 text-right md:text-left'>Let's Connect</h1>
          <p className='text-sm md:text-base text-white/70'>
            Ready to bring your ideas to life? Drop me a message and let's create something amazing together.
          </p>
        </div>

        <div className='flex-1 flex flex-col lg:flex-row gap-8 pb-8 pb-safe-bottom'>
          {/* Contact Form */}
          <div className='flex-1'>
            <form action="https://formsubmit.co/aelghamriny@gmail.com" method="POST" className='space-y-6'>
              {/* Name and Email Row */}
              <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                <div className='relative'>
                  <input
                    type='text'
                    name='name'
                    value={formData.name}
                    onChange={handleChange}
                    placeholder='Your Name'
                    required
                    className='w-full p-4 bg-white/10 border border-white/20 rounded-2xl backdrop-blur-sm 
                             text-white placeholder-white/50 focus:outline-none focus:border-white/40 
                             focus:bg-white/15 transition-all duration-300'
                  />
                </div>
                <div className='relative'>
                  <input
                    type='email'
                    name='email'
                    value={formData.email}
                    onChange={handleChange}
                    placeholder='Your Email'
                    required
                    className='w-full p-4 bg-white/10 border border-white/20 rounded-2xl backdrop-blur-sm 
                             text-white placeholder-white/50 focus:outline-none focus:border-white/40 
                             focus:bg-white/15 transition-all duration-300'
                  />
                </div>
              </div>

              {/* Subject */}
              <div className='relative'>
                <input
                  type='text'
                  name='subject'
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder='Subject'
                  required
                  className='w-full p-4 bg-white/10 border border-white/20 rounded-2xl backdrop-blur-sm 
                           text-white placeholder-white/50 focus:outline-none focus:border-white/40 
                           focus:bg-white/15 transition-all duration-300'
                />
              </div>

              {/* Message */}
              <div className='relative'>
                <textarea
                  name='message'
                  value={formData.message}
                  onChange={handleChange}
                  placeholder='Your Message'
                  rows={6}
                  required
                  className='w-full p-4 bg-white/10 border border-white/20 rounded-2xl backdrop-blur-sm 
                           text-white placeholder-white/50 focus:outline-none focus:border-white/40 
                           focus:bg-white/15 transition-all duration-300 resize-none'
                />
              </div>

              {/* Submit Button */}
              <button
                type='submit'
                className='group relative w-full md:w-auto px-8 py-4 bg-white/10 border-2 border-white/30 
                         rounded-3xl overflow-hidden backdrop-blur-sm transition-all duration-300 ease-out 
                         hover:border-white/60 hover:bg-white/20 hover:scale-105 hover:shadow-lg
                         font-stretchRegular text-sm md:text-base'
              >
                <div className='flex items-center justify-center gap-3 relative z-10'>
                  <span className='transition-transform duration-300 group-hover:-translate-x-1'>
                    SEND MESSAGE
                  </span>
                  <Send 
                    size={18} 
                    className='transition-all duration-300 ease-out transform translate-x-8 opacity-0 
                             group-hover:translate-x-0 group-hover:opacity-100 group-hover:rotate-12' 
                  />
                </div>
                {/* Sliding background effect */}
                <div className='absolute inset-0 bg-gradient-to-r from-white/5 to-white/15 transform 
                               -translate-x-full transition-transform duration-300 ease-out group-hover:translate-x-0'>
                </div>
              </button>
            </form>
          </div>

          {/* Contact Info & Social Media */}
          <div className='lg:w-80 space-y-8'>
            {/* Contact Info */}
            <div className='space-y-4'>
              <h3 className='text-xl md:text-2xl font-stretchRegular mb-4'>Get In Touch</h3>
              
              <div className='space-y-3'>
                <div className='flex items-center gap-3 text-white/80 hover:text-white transition-colors duration-300'>
                  <Mail size={18} className='flex-shrink-0' />
                  <span className='text-sm md:text-base'>aelghamriny@gmail.com</span>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className='space-y-4'>
              <h3 className='text-xl md:text-2xl font-stretchRegular mb-4'>Follow Me</h3>
              
              <div className='grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-2'>
                {/* LinkedIn */}
                <a
                  href='https://www.linkedin.com/in/ahmedelghamriny/'
                  target="_blank"
                  rel="noopener noreferrer"
                  className='group flex items-center justify-center gap-3 p-3 bg-white/10 border border-white/20 
                           rounded-xl backdrop-blur-sm hover:bg-white/20 hover:border-white/40 hover:scale-105 
                           transition-all duration-300'
                >
                  <Linkedin size={20} className='text-blue-400 group-hover:scale-110 transition-transform duration-300' />
                  <span className='text-xs font-medium'>LinkedIn</span>
                </a>

                {/* GitHub */}
                <a
                  href='https://github.com/AhmedElghamriny'
                  target="_blank"
                  rel="noopener noreferrer"
                  className='group flex items-center justify-center gap-3 p-3 bg-white/10 border border-white/20 
                           rounded-xl backdrop-blur-sm hover:bg-white/20 hover:border-white/40 hover:scale-105 
                           transition-all duration-300'
                >
                  <Github size={20} className='text-gray-300 group-hover:scale-110 transition-transform duration-300' />
                  <span className='text-xs font-medium'>GitHub</span>
                </a>

                {/* Instagram */}
                <a
                  href='https://www.instagram.com/ahmed.elghamriny'
                  target="_blank"
                  rel="noopener noreferrer"
                  className='group flex items-center justify-center gap-3 p-3 bg-white/10 border border-white/20 
                           rounded-xl backdrop-blur-sm hover:bg-white/20 hover:border-white/40 hover:scale-105 
                           transition-all duration-300'
                >
                  <Instagram size={20} className='text-pink-400 group-hover:scale-110 transition-transform duration-300' />
                  <span className='text-xs font-medium'>Instagram</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Contact = () => {
  return (
    <div className='bg-black p-4 md:p-8 flex flex-col'
         style={{
           height: '100dvh',
           minHeight: '100svh'
         }}>
      <div className='flex-1 min-h-0'>
        <GradientContainer components={[<ContactForm key="contact-form"/>]}/>
      </div>
      <div className='absolute text-white opacity-30 text-xs'
           style={{
             bottom: 'max(0.5rem, env(safe-area-inset-bottom))',
             left: 'max(0.5rem, env(safe-area-inset-left))'
           }}>
        &copy; AHMED ELGHAMRINY
      </div>
    </div>
  )
}

export default Contact;